import textStyles from '../TextMenu.module.css'
import exSELF from "../../Img/Menu/Activate/exSelf.png";
import exSELF2 from "../../Img/Menu/Activate/selfReg2.png";
import {Helmet} from "react-helmet";
import React from "react";
export default function MenuActivate(){
    return(
        <div className={textStyles.mainCont}>
            <Helmet>
                <title>sim-unlim : Активация</title>
                <link rel="canonical" href="https://sim-unlim.com/activate" />
                <meta name="description" content="Активация госуслуги логовор подпись" />
            </Helmet>
            <div className={textStyles.blCont}>
                <div className={textStyles.head}><p>Активация SIM карты</p></div>


                <p className={textStyles.ident}>
                    Что такое активация SIM карты - это процесс внесения персональных данных в ИС (информационную систему) оператора мобильной связи. Инструкция по активации карты, приходит
                    вместе с самой SIM картой. Существует несколько способов активации :
                </p>

                <div className={textStyles.lsCont}>
                    <ul>
                        <li>
                            <div className={textStyles.plCont}>
                                <div>Активация через наш сервис, инструкция придет вместе в SIM картой</div>
                            </div>
                        </li>
                        <li>
                            <div className={textStyles.plCont}>
                                <div>Активация через саморегистрацию, в таком случае активацию  Вы делаете сами, посредством сервиса «Госуслуги». В таком
                                случае Вы не передаете нам персональных данных, кроме контактных. Инструкция так же поступит вместе в SIM картой</div>
                            </div>

                        </li>
                        <li>
                            <div className={textStyles.plCont}>
                                <div>Активация при способе доставки через салон связи, в таком случае требуется «сэлфи» фото с документом в руках</div>
                            </div>

                        </li>
                    </ul>

                </div>

            </div>
            <hr className={textStyles.hr}></hr>
            <p className={textStyles.ident}>
                Не все тарифы поддерживают саморегистрацию. Наличие возможности саморегистрации отображено в виде пиктограммы в карточке тарифа.


            </p>
            <div className={textStyles.cenCont}>
                <div className={textStyles.imgCont}>
                    <img className={textStyles.widthImg} src={exSELF}></img>
                    <div className={textStyles.imgTitle}>Рисунок 1. (Наличие возможности саморегистрации у тарифа)</div>
                </div>
            </div>
            <p className={textStyles.ident}>
                Если Вы хотите воспользоваться режимом саморегистрации, следует установить галочку в процессе оформления заказа

            </p>
            <div className={textStyles.cenCont}>
                <div className={textStyles.imgCont}>
                    <img className={textStyles.widthImg} src={exSELF2}></img>
                    <div className={textStyles.imgTitle}>Рисунок 2. (Выбор режима саморегистрации)</div>
                </div>
            </div>


        </div>

    )
}